
import { useTranslation } from 'react-i18next';

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-line-chart-line',
      title: t('platform.epg'),
      description: t('platform.pct'),
      color: 'bg-blue-500'
    },
    {
      icon: 'ri-flashlight-line',
      title: t('platform.lfe'),
      description: t('platform.ull'),
      color: 'bg-green-500'
    },
    {
      icon: 'ri-robot-line',
      title: t('platform.ea'),
      description: t('platform.atc'),
      color: 'bg-purple-500'
    },
    {
      icon: 'ri-shield-check-line',
      title: t('platform.rm'),
      description: t('platform.crm'),
      color: 'bg-red-500'
    },
    {
      icon: 'ri-smartphone-line',
      title: t('platform.mpa'),
      description: t('platform.tsa'),
      color: 'bg-amber-500'
    },
    {
      icon: 'ri-global-line',
      title: t('platform.gm'),
      description: t('platform.ati'),
      color: 'bg-indigo-500'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('platform.ptf')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
             {t('platform.epg')}
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              <div className={`w-16 h-16 ${feature.color} rounded-xl flex items-center justify-center mb-6  transition-transform duration-300`}>
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
